export default __webpack_public_path__ + "static/media/regulatory--no-bicycles-or-hand-carts--g1.b307cb32.png";